import React from 'react'
import classNames from 'classnames'

export default ({className, iconName}) => (
  <svg className={classNames('icon', className)} aria-hidden="true">
    <use xlinkHref={`#icon-${iconName}`} />
  </svg>
)
